@if (disabled() || !hasContent()) {
  <ng-content/>
} @else {
  <span class="help-tip-trigger"
        [matTooltip]="tooltipText()"
        [matTooltipShowDelay]="delay()"
        matTooltipClass="help-tip-multiline">
    <ng-content/>
  </span>
}
